import { GridContainer } from 'libs/ui';
import { GreyPlate } from 'grids/grey-plate/grey-plate';

export const GreyPlateWrapper = (props) => {
  return (
    <GridContainer>
      <GreyPlate {...props} />
    </GridContainer>
  );
};
